export enum LOG_LEVEL {
  DEBUG,
  INFO,
  WARN,
  ERROR,
}

export default LOG_LEVEL;
